exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".responsive[data-v-35e52591] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow-x: auto;\n}", ""]);

// exports
